(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vp-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const PERFILES_SIN_VENTA = ['path_a', 'path_b', 'path_c'];

    function tiene(lista, valor) {
      return Array.isArray(lista) && lista.indexOf(valor) !== -1;
    }

    function resolver(r) {
      const avisos = [];
      const q5a = r.q5a || [];
      const q5b = r.q5b || [];

      if (r.q2 === 'menor') return { perfil: 'path_a', avisos: avisos };
      if (tiene(q5a, 'embarazo')) return { perfil: 'path_b', avisos: avisos };
      if (r.q4 === 'placas' || r.q6 === 'alarma') return { perfil: 'path_c', avisos: avisos };

      if (tiene(q5a, 'lactancia')) avisos.push('lactancia');
      if (tiene(q5b, 'injerto')) avisos.push('injerto');
      if (r.q3 === 'mas12') avisos.push('cronico');

      const preventivo = r.q3 === 'preventivo' || r.q4 === 'preventivo';
      const esHombre = r.q1 === 'hombre';
      let perfil;

      if (esHombre) {
        if (tiene(q5b, 'antecedentes') && r.q4 === 'zonas') perfil = 'p4';
        else if (r.q4 === 'zonas') perfil = 'p4';
        else if (tiene(q5b, 'estres') || tiene(q5b, 'alimentacion') || tiene(q5b, 'injerto')) perfil = 'p5';
        else if (preventivo) perfil = 'p6';
        else perfil = 'p5';
      } else {
        if (tiene(q5a, 'postparto')) perfil = 'p2';
        else if (tiene(q5a, 'menopausia')) perfil = 'p1';
        else if (r.q4 === 'fino' && (r.q2 === '45a54' || r.q2 === '55mas')) perfil = 'p1';
        else if (tiene(q5a, 'estres')) perfil = 'p3';
        else if (preventivo) perfil = 'p6';
        else perfil = 'p3';
      }

      return {
        perfil: perfil,
        avisos: avisos,
        topico: r.q4 === 'textura' || r.q6 === 'seco' || r.q6 === 'graso' || r.q6 === 'sensible'
      };
    }

    function etiquetas(r, resultado, marketing) {
      const tags = ['cuestionario', 'perfil-' + resultado.perfil.replace('_', '-')];
      if (marketing) tags.push('acepta-comunicaciones');
      if (r.q1) tags.push('sexo-' + r.q1);
      if (r.q2) tags.push('edad-' + r.q2);
      if (r.q4) tags.push('cabello-' + r.q4);
      if (r.q6) tags.push('cuero-' + r.q6);
      if (r.q7) tags.push('probado-' + r.q7);
      (resultado.avisos || []).forEach(function (a) {
        tags.push('aviso-' + a);
      });
      (r.q8 || []).slice(0, 2).forEach(function (o) {
        tags.push('objetivo-' + o);
      });
      return tags.join(',');
    }

    function animar(nodo) {
      if (!window.gsap) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const objetivos = nodo.querySelectorAll('.vp-quiz__option, .vp-quiz__field, .vp-quiz__pillar, .vp-quiz__product');
      window.gsap.from(nodo, { opacity: 0, y: 12, duration: 0.4, ease: 'power2.out', clearProps: 'all' });
      if (objetivos.length) {
        window.gsap.from(objetivos, {
          opacity: 0,
          y: 10,
          duration: 0.35,
          stagger: 0.05,
          delay: 0.08,
          ease: 'power2.out',
          clearProps: 'all'
        });
      }
    }

    function iniciar(raiz) {
      if (raiz.dataset.vpListo === 'true') return;
      raiz.dataset.vpListo = 'true';

      const clave = raiz.dataset.vpKey;
      const pantallas = Array.prototype.slice.call(raiz.querySelectorAll('[data-vp-screen]'));
      const preguntas = pantallas.filter(function (p) {
        return p.dataset.vpScreen === 'pregunta';
      });
      const pantallaEmail = raiz.querySelector('[data-vp-screen="email"]');
      const pantallaResultado = raiz.querySelector('[data-vp-screen="resultado"]');
      const progreso = raiz.querySelector('[data-vp-progress]');
      const barra = raiz.querySelector('[data-vp-progress-fill]');
      const pista = raiz.querySelector('[data-vp-progress-track]');
      const textoProgreso = raiz.querySelector('[data-vp-progress-text]');
      const formulario = raiz.querySelector('.vp-quiz__form');
      const avisoEnviando = raiz.querySelector('[data-vp-enviando]');
      const campoTags = raiz.querySelector('[data-vp-tags]');
      const campoNombre = raiz.querySelector('[name="contact[first_name]"]');
      const plantillaProgreso = textoProgreso ? textoProgreso.dataset.vpPlantilla || '' : '';

      const marcos = Array.prototype.slice.call(raiz.querySelectorAll('[data-vp-media-stack] [data-vp-media]'));

      // La política de privacidad y los avisos legales se abren en otra pestaña:
      // si se abren encima, el visitante pierde el cuestionario entero y vuelve
      // a la pantalla de bienvenida con todo en blanco.
      Array.prototype.forEach.call(
        raiz.querySelectorAll('.vp-quiz__consent a[href], .vp-quiz__disclaimer a[href]'),
        function (enlace) {
          if (enlace.target) return;
          enlace.target = '_blank';
          enlace.rel = 'noopener';
        }
      );

      const respuestas = {};
      let indice = -1;
      let porFlecha = false;
      let mediosDespiertos = false;
      let avanceProgramado = null;
      let arrancando = true;
      let envioEnMarcha = false;

      // Las imágenes de las preguntas se quedan fuera de la carga inicial: solo pesa la portada.
      // En cuanto el visitante entra al cuestionario las soltamos para que bajen mientras responde.
      function despertarMedios() {
        if (mediosDespiertos) return;
        mediosDespiertos = true;
        marcos.forEach(function (marco) {
          marco.hidden = false;
        });
      }

      function pintarMedia(pantalla) {
        if (!marcos.length) return;
        despertarMedios();
        const clave = pantalla ? pantalla.dataset.vpMedia || '' : '';
        // Un fotograma de margen: si el marco acaba de salir de hidden, así le da tiempo a fundirse.
        window.requestAnimationFrame(function () {
          marcos.forEach(function (marco) {
            marco.classList.toggle('is-active', clave !== '' && marco.dataset.vpMedia === clave);
          });
        });
      }

      function visibles() {
        return preguntas.filter(function (p) {
          const rama = p.dataset.vpRama;
          if (rama === 'todos') return true;
          if (rama === 'hombre') return respuestas.q1 === 'hombre';
          return respuestas.q1 !== 'hombre';
        });
      }

      // Al cambiar de pantalla el alto de la página cambia de golpe. Si no se
      // recoloca, el visitante se queda mirando el medio de la pantalla nueva
      // (o el pie, cuando el resultado es más corto que el formulario) y cree
      // que no ha pasado nada. Solo se mueve si hace falta.
      function traerALaVista(pantalla) {
        if (arrancando) return;
        const margen = 90; // la cabecera de la tienda es fija
        const caja = pantalla.getBoundingClientRect();
        if (caja.top >= margen - 8 && caja.top <= window.innerHeight * 0.5) return;
        const quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({
          top: Math.max(0, caja.top + window.pageYOffset - margen),
          behavior: quieto ? 'auto' : 'smooth'
        });
      }

      function mostrar(pantalla, conFoco) {
        pantallas.forEach(function (p) {
          p.hidden = p !== pantalla;
          p.classList.toggle('is-active', p === pantalla);
        });
        raiz.classList.toggle('is-resultado', pantalla === pantallaResultado);
        pintarMedia(pantalla);
        animar(pantalla);
        traerALaVista(pantalla);
        if (conFoco !== false) {
          const foco = pantalla.querySelector('[tabindex="-1"]');
          if (foco) foco.focus({ preventScroll: true });
        }
      }

      function pintarProgreso() {
        if (!progreso) return;
        const lista = visibles();
        const total = lista.length || parseInt(raiz.dataset.vpTotal, 10) || 8;
        const visible = indice >= 0;
        progreso.hidden = !visible;
        if (!visible) return;
        const ultimo = indice >= total;
        const actual = ultimo ? total : indice + 1;
        if (barra) barra.style.width = (actual / total) * 100 + '%';
        if (pista) {
          pista.setAttribute('aria-valuenow', String(actual));
          pista.setAttribute('aria-valuemax', String(total));
        }
        if (textoProgreso) {
          textoProgreso.textContent = ultimo
            ? textoProgreso.dataset.vpUltimo || ''
            : plantillaProgreso.replace('{actual}', String(actual)).replace('{total}', String(total));
        }
      }

      function irA(i) {
        const lista = visibles();
        if (i < 0) {
          indice = -1;
          pintarProgreso();
          mostrar(pantallas[0]);
          return;
        }
        if (i >= lista.length) {
          indice = lista.length;
          pintarProgreso();
          if (pantallaEmail) mostrar(pantallaEmail);
          return;
        }
        indice = i;
        pintarProgreso();
        mostrar(lista[i]);
        sincronizarBoton(lista[i]);
      }

      function sincronizarBoton(pantalla) {
        const siguiente = pantalla.querySelector('[data-vp-next]');
        if (!siguiente) return;
        const marcados = pantalla.querySelectorAll('[data-vp-answer]:checked');
        siguiente.disabled = marcados.length === 0;
      }

      function guardar(pantalla) {
        const q = pantalla.dataset.vpQ;
        const marcados = Array.prototype.slice.call(pantalla.querySelectorAll('[data-vp-answer]:checked'));
        if (pantalla.dataset.vpTipo === 'multi') {
          respuestas[q] = marcados.map(function (m) {
            return m.value;
          });
        } else {
          respuestas[q] = marcados.length ? marcados[0].value : null;
        }
        // Se guardan según se responden: si el envío acaba recargando la
        // página, las respuestas ya están a salvo pase lo que pase.
        recordar(false);
      }

      // El alta del contacto recarga la página (la manda el navegador para que
      // Shopify pueda poner su token anti-bot), así que las respuestas viajan
      // en la sesión del navegador junto a la marca de "esto ya se ha enviado".
      function recordar(enviado, alta) {
        try {
          window.sessionStorage.setItem(
            clave,
            JSON.stringify({ respuestas: respuestas, enviado: enviado === true, alta: alta || null, ts: Date.now() })
          );
        } catch (e) {}
      }

      function recordado() {
        try {
          const crudo = window.sessionStorage.getItem(clave);
          if (!crudo) return null;
          const datos = JSON.parse(crudo);
          if (!datos || typeof datos !== 'object') return null;
          // Formato anterior: el objeto de respuestas pelado.
          if (!datos.respuestas) return { respuestas: datos, enviado: true, alta: 'ok', ts: 0 };
          if (datos.ts && Date.now() - datos.ts > 3600000) return null;
          return datos;
        } catch (e) {
          return null;
        }
      }

      function pintarResultado(sinAlta) {
        if (!pantallaResultado) return;
        const resultado = resolver(respuestas);

        const avisoSinAlta = pantallaResultado.querySelector('[data-vp-sin-alta]');
        if (avisoSinAlta) avisoSinAlta.hidden = sinAlta !== true;

        const saludo = pantallaResultado.querySelector('[data-vp-saludo]');
        const nombre = campoNombre ? campoNombre.value.trim() : '';
        if (saludo && nombre && saludo.dataset.vpSaludo) {
          saludo.textContent = saludo.dataset.vpSaludo.replace('{nombre}', nombre);
        }

        const paneles = pantallaResultado.querySelectorAll('[data-vp-result]');
        Array.prototype.forEach.call(paneles, function (panel) {
          panel.hidden = panel.dataset.vpResult !== resultado.perfil;
        });

        const avisos = pantallaResultado.querySelectorAll('[data-vp-aviso]');
        Array.prototype.forEach.call(avisos, function (aviso) {
          aviso.hidden = (resultado.avisos || []).indexOf(aviso.dataset.vpAviso) === -1;
        });

        const conVenta = PERFILES_SIN_VENTA.indexOf(resultado.perfil) === -1;
        const cupon = pantallaResultado.querySelector('[data-vp-cupon]');
        const expectativas = pantallaResultado.querySelector('[data-vp-expectativas]');
        if (cupon) cupon.hidden = !conVenta;
        if (expectativas) expectativas.hidden = !conVenta;

        if (resultado.topico && conVenta) {
          const activo = pantallaResultado.querySelector('[data-vp-result]:not([hidden])');
          const contenedor = activo ? activo.querySelector('.vp-quiz__products') : null;
          const secundario = contenedor ? contenedor.querySelector('[data-vp-producto="secundario"]') : null;
          if (contenedor && secundario) {
            contenedor.insertBefore(secundario, contenedor.firstChild);
            secundario.classList.add('vp-quiz__product--destacado');
          }
        }

        if (progreso) progreso.hidden = true;
        mostrar(pantallaResultado);
      }

      preguntas.forEach(function (pantalla) {
        const entradas = pantalla.querySelectorAll('[data-vp-answer]');
        Array.prototype.forEach.call(entradas, function (entrada) {
          entrada.addEventListener('keydown', function (evento) {
            porFlecha =
              evento.key === 'ArrowDown' ||
              evento.key === 'ArrowUp' ||
              evento.key === 'ArrowLeft' ||
              evento.key === 'ArrowRight';
          });

          entrada.addEventListener('change', function () {
            if (pantalla.dataset.vpTipo === 'multi') {
              if (entrada.value === 'ninguna' && entrada.checked) {
                Array.prototype.forEach.call(entradas, function (otra) {
                  if (otra !== entrada) otra.checked = false;
                });
              } else if (entrada.checked) {
                Array.prototype.forEach.call(entradas, function (otra) {
                  if (otra.value === 'ninguna') otra.checked = false;
                });
              }
            }
            guardar(pantalla);
            sincronizarBoton(pantalla);
            if (pantalla.dataset.vpTipo !== 'multi' && !porFlecha) {
              // Si cambia de opción antes de que salte el avance, se anula el
              // anterior: si no, se encadenaban dos saltos y se comía la
              // pregunta siguiente sin contestar.
              window.clearTimeout(avanceProgramado);
              avanceProgramado = window.setTimeout(function () {
                irA(indice + 1);
              }, 220);
            }
            porFlecha = false;
          });
        });

        const siguiente = pantalla.querySelector('[data-vp-next]');
        if (siguiente) {
          siguiente.addEventListener('click', function () {
            guardar(pantalla);
            irA(indice + 1);
          });
        }

        const atras = pantalla.querySelector('[data-vp-back]');
        if (atras) {
          atras.addEventListener('click', function () {
            irA(indice - 1);
          });
        }
      });

      const empezar = raiz.querySelector('[data-vp-start]');
      if (empezar) {
        empezar.addEventListener('click', function () {
          irA(0);
        });
      }

      // "Enviármelo por email": vuelve al formulario con lo que ya había
      // escrito, para que pueda reintentar el alta sin rehacer el cuestionario.
      const volverEmail = raiz.querySelector('[data-vp-volver-email]');
      if (volverEmail && pantallaEmail) {
        volverEmail.addEventListener('click', function () {
          envioEnMarcha = false;
          if (avisoEnviando) avisoEnviando.hidden = true;
          mostrar(pantallaEmail);
        });
      }

      const reiniciar = raiz.querySelector('[data-vp-reiniciar]');
      if (reiniciar) {
        reiniciar.addEventListener('click', function () {
          envioEnMarcha = false;
          if (avisoEnviando) avisoEnviando.hidden = true;
          Object.keys(respuestas).forEach(function (k) {
            delete respuestas[k];
          });
          preguntas.forEach(function (pantalla) {
            const entradas = pantalla.querySelectorAll('[data-vp-answer]');
            Array.prototype.forEach.call(entradas, function (e) {
              e.checked = false;
            });
            sincronizarBoton(pantalla);
          });
          try {
            window.sessionStorage.removeItem(clave);
          } catch (e) {}
          irA(-1);
        });
      }

      const copiar = raiz.querySelector('[data-vp-copiar]');
      if (copiar) {
        copiar.addEventListener('click', function () {
          const codigo = raiz.querySelector('[data-vp-codigo]');
          const estado = raiz.querySelector('[data-vp-copy-status]');
          const texto = codigo ? codigo.textContent.trim() : '';
          if (!texto) return;

          const exito = function () {
            copiar.textContent = copiar.dataset.vpLabelCopiado;
            if (estado) estado.textContent = copiar.dataset.vpLabelCopiado;
            window.setTimeout(function () {
              copiar.textContent = copiar.dataset.vpLabelCopiar;
            }, 2600);
          };

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(texto).then(exito, function () {
              if (estado) estado.textContent = texto;
            });
          } else if (estado) {
            estado.textContent = texto;
          }
        });
      }

      // ¿Hay un rompecabezas anti-bot delante? Mientras esté, se le deja
      // resolverlo; si lo abandona, el resultado sale igual. Ojo: Shopify deja
      // siempre un par de marcos de hCaptcha en la página, uno a 0x0 y otro de
      // 300x150 aparcado fuera de pantalla; esos no cuentan.
      function hayRetoVisible() {
        const marcos = document.querySelectorAll(
          'iframe[src*="hcaptcha"], iframe[src*="recaptcha"], iframe[title*="challenge"]'
        );
        for (let i = 0; i < marcos.length; i++) {
          const caja = marcos[i].getBoundingClientRect();
          if (caja.width < 200 || caja.height < 200) continue;
          if (caja.bottom <= 0 || caja.top >= window.innerHeight) continue;
          const estilo = window.getComputedStyle(marcos[i]);
          if (estilo.visibility === 'hidden' || estilo.display === 'none' || estilo.opacity === '0') continue;
          return true;
        }
        return false;
      }

      // Red de seguridad: el alta la manda el navegador y puede quedarse por el
      // camino (el anti-bot de Shopify se traga el envío, la red falla, Shopify
      // devuelve un error). Si a los 6 s seguimos en la misma página, el
      // resultado se enseña igualmente. Si el envío sí sale, la página navega y
      // este reloj se muere con ella.
      function vigilarEnvio() {
        const arranque = Date.now();
        const reloj = window.setInterval(function () {
          const pasado = Date.now() - arranque;
          if (pasado < 6000) return;
          if (pasado < 20000 && hayRetoVisible()) return;
          window.clearInterval(reloj);
          if (avisoEnviando) avisoEnviando.hidden = true;
          // Si seguimos aquí, el alta no ha salido: resultado sí, pero se le
          // dice que su email no ha quedado guardado.
          if (pantallaResultado && pantallaResultado.hidden) pintarResultado(true);
        }, 500);
      }

      if (formulario) {
        const arrancarEnvio = function (evento) {
          if (envioEnMarcha) return;
          // Si falta algo obligatorio, el navegador ya lo señala: aquí no
          // damos por enviado nada.
          if (formulario.checkValidity && !formulario.checkValidity()) return;
          envioEnMarcha = true;

          const marketing = formulario.querySelector('[data-vp-marketing]');
          const resultado = resolver(respuestas);
          if (campoTags) campoTags.value = etiquetas(respuestas, resultado, marketing && marketing.checked);

          recordar(true, null);

          // Sin consentimiento de comunicaciones (cuando el ajuste lo permite)
          // no se da de alta a nadie: se enseña el resultado y ya está.
          if (marketing && !marketing.checked && !marketing.required) {
            evento.preventDefault();
            pintarResultado(false);
            return;
          }

          if (avisoEnviando) avisoEnviando.hidden = false;

          // El alta la envía el navegador de forma normal, sin fetch. Es la
          // única manera de que Shopify enganche su token anti-bot al envío:
          // mandándolo por fetch, el POST a /contact volvía SIEMPRE 400
          // «Missing CAPTCHA token», saltaba el rompecabezas de hCaptcha en
          // inglés encima del formulario y el visitante se quedaba sin
          // resultado. Al volver de Shopify, el bloque final lo repinta.
          vigilarEnvio();
        };

        // Por el botón y por el Intro del teclado. El anti-bot de Shopify puede
        // quedarse con el evento submit, así que el clic también cuenta.
        const botonEnvio = formulario.querySelector('[type="submit"]');
        if (botonEnvio) botonEnvio.addEventListener('click', arrancarEnvio);
        formulario.addEventListener('submit', arrancarEnvio);
      }

      const yaEnviado = raiz.querySelector('[data-vp-posted]');
      const conErrores = raiz.querySelector('[data-vp-errores]');
      const memoria = recordado();

      if (memoria && memoria.respuestas) {
        Object.keys(memoria.respuestas).forEach(function (k) {
          respuestas[k] = memoria.respuestas[k];
        });
      }

      arrancando = false;

      // Quien ha contestado el cuestionario ve su resultado pase lo que pase
      // con el alta: la acepte Shopify, devuelva un error o se quede por el
      // camino. El resultado es lo que se le ha prometido; el lead es aparte.
      if (yaEnviado || conErrores || (memoria && memoria.enviado)) {
        const alta = yaEnviado ? 'ok' : conErrores ? 'error' : memoria && memoria.alta;
        recordar(true, alta);
        pintarResultado(alta !== 'ok');
      } else {
        pantallas.forEach(function (p, i) {
          p.hidden = i !== 0;
        });
      }

      if (marcos.length) {
        if (document.readyState === 'complete') {
          window.setTimeout(despertarMedios, 400);
        } else {
          window.addEventListener(
            'load',
            function () {
              window.setTimeout(despertarMedios, 400);
            },
            { once: true }
          );
        }
      }

      // En el editor de temas: al seleccionar una pregunta se salta a su pantalla,
      // para que el comerciante vea la imagen que está cambiando. El evento burbujea.
      raiz.addEventListener('shopify:block:select', function (evento) {
        const destino = evento.target.closest ? evento.target.closest('[data-vp-screen="pregunta"]') : null;
        if (!destino) return;
        const posicion = visibles().indexOf(destino);
        if (posicion === -1) {
          mostrar(destino);
          return;
        }
        irA(posicion);
      });
    }

    function arrancar(contexto) {
      const raices = (contexto || document).querySelectorAll('[data-vp-quiz]');
      Array.prototype.forEach.call(raices, iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        arrancar(document);
      });
    } else {
      arrancar(document);
    }

    document.addEventListener('shopify:section:load', function (evento) {
      arrancar(evento.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
